import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// Auto-recover from stale chunk errors after a redeploy (old hashed JS no longer exists).
// Reload once so the browser fetches the new index.html and asset graph.
const RELOAD_KEY = "gn_chunk_reload_at";
const RELOAD_COOLDOWN_MS = 10_000;
function reloadWithFreshAssets() {
  const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
  if (Date.now() - last < RELOAD_COOLDOWN_MS) return;
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  const url = new URL(window.location.href);
  url.searchParams.set("v", String(Date.now()));
  window.location.replace(url.toString());
}

function handleChunkError(message?: string) {
  if (!message) return;
  const isChunkErr =
    message.includes("Importing a module script failed") ||
    message.includes("Failed to fetch dynamically imported module") ||
    message.includes("error loading dynamically imported module") ||
    message.includes("Load failed") ||
    message.includes("dynamically imported module");
  if (!isChunkErr) return;
  reloadWithFreshAssets();
}
window.addEventListener("error", (e) => handleChunkError(e?.message));
window.addEventListener("unhandledrejection", (e) =>
  handleChunkError(String(e?.reason?.message || e?.reason || ""))
);
// Vite's preload helper dispatches this when a chunk fails to load
window.addEventListener("vite:preloadError", () => {
  reloadWithFreshAssets();
});

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
